export default __webpack_public_path__ + "static/media/choco-box@2x.76f17c89.png";